import React from "react";
import {
  EmptyMessage,
  FactRow,
  FactsPanel,
} from "./DataStudioColumnFactsPanel.styles";
import type { DataStudioColumnFactsPanelProps } from "./DataStudioColumnFactsPanel.types";

export const DataStudioColumnFactsPanel: React.FC<
  DataStudioColumnFactsPanelProps
> = ({
  facts,
  ariaLabel = "Column profile details",
  emptyMessage = "No column details are available.",
}) => (
  <FactsPanel aria-label={ariaLabel}>
    {facts.length ? (
      facts.map((fact, index) => (
        <FactRow
          key={`${fact.key}-${index}`}
          label={fact.key}
          value={fact.value}
        />
      ))
    ) : (
      <EmptyMessage role="status">{emptyMessage}</EmptyMessage>
    )}
  </FactsPanel>
);

export default DataStudioColumnFactsPanel;
